import {olivioLayouts as layouts} from '../../layouts/olivioLayouts';

const designsConfigs = {
	sistema: {
		configValues: {
			poleHeight: 10,
			numberOfHeads: 8,
			bracket: '1',
			layoutType: 'spiral',
			housingSize: 'grande',
			color: '#666',
			heightMax: 9,
			heightMin: 5,
			angleMax: 360,
			angleMin: 0,
			heads: [],
			selectedHead: null,
		},
		position: [-4, 0, 0]
	},

	floracion: {
		configValues: {
			poleHeight: 8,
			numberOfHeads: 6,
			bracket: '1',
			layoutType: 'spiral',
			housingSize: 'grande',
			color: '#666',
			colorInlay: '#666', //'#474A51',
			colorPole: '#666',
			heightMax: 7,
			heightMin: 3,
			angleMax: 360,
			angleMin: 0,
			heads: [],
			selectedHead: null,
			poleMaterial: 'steel',
			poleDiameter: 219,
			woodType: ''
		},
		position: [-2, 0, 0]
	},

	candelabra: {
		configValues: {
			poleHeight: 4.5,
			candelabraTop: '3.000',
			color: '#666',
			numberOfHeads: 3,
			housingSize: 'grande',
			layout: 'none',
			heads: [],
			selectedHead: null,
		},
		position: [0, 0, 0]
	},

	bollard: {
		configValues: {
			color: '#666', //'#666',
			poleHeight: 1.2,
			numberOfHeads: 1,
		},
		position: [2, 0, 0]
	},

	universal: {
		configValues: {
			color: '#666', //'#666',
			poleHeight: 0,
			numberOfHeads: 1,
			heads: [],
		},
		position: [4, 0, 0]
	}

};

for (const designName of ['sistema', 'floracion']) {
	const layout = layouts.spiral.calculate(designName, designsConfigs[designName].configValues);
	const branches = layout.branches;
	for (let i = 0; i < 8; i++) {
		const head = {
			active: i < branches.length,
			type: 'luminaire', //luminaire, gobo, speaker, camera
			housingSize: 'grande',
			height: i < branches.length ? branches[i].height : 0,
			angle: i < branches.length ? branches[i].angle : 0,
			dimmingLevel: null,
			colourTemperature: null,
			lightDistribution: null,
			reflectorColor: null,
			accessories: 'None',
			goboAperture: 'normal', // extrawide, wide, normal, long
			spcDecisions: null,
			collisions: [],
		};
		designsConfigs[designName].configValues.heads.push(head);
	}
}

for (const designName of ['candelabra', 'universal']) {
	for (let i = 0; i < 8; i++) {
		const head = {
			active: i < designsConfigs[designName].configValues.numberOfHeads,
			type: 'luminaire', //luminaire, gobo, speaker, camera
			housingSize: 'grande',
			height: 0,
			angle: 0,
			dimmingLevel: null,
			colourTemperature: null,
			lightDistribution: null,
			reflectorColor: null,
			accessories: 'None',
			goboAperture: 'normal', // extrawide, wide, normal, long
			spcDecisions: null,
			collisions: [],
		};
		designsConfigs[designName].configValues.heads.push(head);
	}
}

export {designsConfigs};
